import store from '../store/store';
import TranslationMode from '../store/schema/TranslationMode';

export default function shouldTranslateAutomatic(locale: string): boolean {
    return (
        store.settings.translationMode === TranslationMode.Automatic &&
        !store.settings.excludedLanguages.includes(locale)
    );
}
